import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useSkipOneDayEmailVerificationLatency = () => {
  const {
    flags: {
      useSkipOneDayEmailVerificationLatency:
        skipOneDayEmailVerificationLatencyFlagValue = false,
    },
  } = useFeatureFlags();
  return skipOneDayEmailVerificationLatencyFlagValue;
};
